import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../../enums/contentStack.js";
import { findOneBusinessEntry, DEFAULT_FIELD_EXCEPTIONS } from "../../../../services/content/business.lib.js";
import { ClientSideAnnouncementBanner } from "./ClientSideAnnouncementBanner.js";
const COMPONENT_NAME = "AnnouncementBanner";
const AnnouncementBanner = async ({
  entryId,
  locale = "en-us",
  enableLivePreview,
  analyticsTitlePrefix
}) => {
  const bannerEntry = await findOneBusinessEntry(
    ContentType.AnnouncementBanner,
    entryId,
    locale,
    DEFAULT_FIELD_EXCEPTIONS,
    enableLivePreview
  );
  if (!bannerEntry) {
    console.log(
      `'announcement_banner' content entry with entryId ${entryId} not found in Contentstack`
    );
    return null;
  }
  return /* @__PURE__ */ jsx(
    ClientSideAnnouncementBanner,
    {
      entry: bannerEntry,
      analyticsTitlePrefix
    }
  );
};
AnnouncementBanner.displayName = COMPONENT_NAME;
export {
  AnnouncementBanner
};
